import { Link } from "react-router-dom";
import { AuthShell } from "@/components/layout/AuthShell";
import { Button } from "@/components/ui/button";

export function AccountDeletedPage() {
  return <AuthShell title="アカウントを削除しました" description="同じメールアドレス、Googleアカウント、Microsoftアカウントですぐに新規登録できます。再登録は旧アカウントの復元ではなく、新しいアカウントとして始まります。">
    <div className="flex flex-wrap gap-2"><Button asChild><Link to="/signup">新しいアカウントを登録</Link></Button><Button asChild variant="outline"><Link to="/login">ログインへ戻る</Link></Button></div>
  </AuthShell>;
}
